import { axiosPublic } from './axiosInstance';

export async function sendVerificationCode(email) {
  const response = await axiosPublic.post('/v1/verification/send-code', { email });
  return response.data?.data ?? response.data;
}

export async function verifyCode(email, code) {
  const response = await axiosPublic.post('/v1/verification/verify-code', { email, code });
  return response.data?.data ?? response.data;
}
